export enum DeliveryPhase {
  AWAITING_ACTION = "AWAITING_ACTION",
  PICKUP = "PICKUP",
  DELIVERY = "DELIVERY",
  CANCELLED = "CANCELLED",
}

export enum DeliveryState {
  CREATED = "CREATED",
  PICKUP_REQUESTED = "PICKUP_REQUESTED",
  PICKUP_ASSIGNED = "PICKUP_ASSIGNED",
  SCANNED_FOR_PICKUP = "SCANNED_FOR_PICKUP",
  SCANNED_FOR_DELIVERY = "SCANNED_FOR_DELIVERY",
  PICKED_UP = "PICKED_UP",
  AT_WAREHOUSE = "AT_WAREHOUSE",
  DELIVERY_ASSIGNED = "DELIVERY_ASSIGNED",
  PICKED_UP_FOR_DELIVERY = "PICKED_UP_FOR_DELIVERY",
  IN_TRANSIT = "IN_TRANSIT",
  DELIVERED = "DELIVERED",
  DELIVERED_AT_WAREHOUSE = "DELIVERED_AT_WAREHOUSE",
  AWAITING_RETURN = "AWAITING_RETURN",
  CANCELLED = "CANCELLED",
}

export enum DeliveryStateExplanation {
  CREATED = "The delivery order has been created.",
  PICKUP_REQUESTED = "A request has been made to pick up the package.",
  PICKUP_ASSIGNED = "A pickup agent has been assigned to collect the package.",
  SCANNED_FOR_PICKUP = "The package has been scanned and is ready for pickup.",
  SCANNED_FOR_DELIVERY = "The package has been scanned and is ready for delivery.",
  PICKED_UP = "The package has been picked up from the sender.",
  AT_WAREHOUSE = "The package has arrived at the warehouse.",
  DELIVERY_ASSIGNED = "A delivery agent has been assigned to deliver the package.",
  PICKED_UP_FOR_DELIVERY = "The package has been picked up from the warehouse for delivery.",
  IN_TRANSIT = "The package is currently on the way to its destination.",
  DELIVERED = "The package has been successfully delivered to the recipient.",
  DELIVERED_AT_WAREHOUSE = "The package has been delivered to directly at the warehouse.",
  AWAITING_RETURN = "The package is on its way back to the warehouse.",
  CANCELLED = "The delivery has been cancelled.",
}

export enum DeliveryStateTrackingName {
  CREATED = "Order Placed",
  PICKUP_REQUESTED = "Pickup Requested",
  PICKUP_ASSIGNED = "Pickup Scheduled",
  SCANNED_FOR_PICKUP = "Ready for Pickup",
  SCANNED_FOR_DELIVERY = "Ready for Delivery",
  PICKED_UP = "Picked Up",
  AT_WAREHOUSE = "Arrived at Warehouse",
  DELIVERY_ASSIGNED = "Delivery Scheduled",
  PICKED_UP_FOR_DELIVERY = "Out for Delivery",
  IN_TRANSIT = "In Transit",
  DELIVERED = "Delivered",
  DELIVERED_AT_WAREHOUSE = "Delivered at Warehouse",
  AWAITING_RETURN = "Returning to Warehouse",
  CANCELLED = "Delivery Cancelled",
}


export const DeliveryStageToStateList = new Map<DeliveryPhase, DeliveryState[]>(
  [[
    DeliveryPhase.AWAITING_ACTION, [
      DeliveryState.CREATED,
      DeliveryState.PICKUP_REQUESTED,
      DeliveryState.AT_WAREHOUSE,
      DeliveryState.AWAITING_RETURN,]
  ],
  [
    DeliveryPhase.PICKUP, [
      DeliveryState.PICKUP_ASSIGNED,
      DeliveryState.SCANNED_FOR_PICKUP,
      DeliveryState.PICKED_UP,
    ]
  ],
  [
    DeliveryPhase.DELIVERY, [
      DeliveryState.DELIVERY_ASSIGNED,
      DeliveryState.SCANNED_FOR_DELIVERY,
      DeliveryState.PICKED_UP_FOR_DELIVERY,
      DeliveryState.IN_TRANSIT,
      DeliveryState.DELIVERED,
      DeliveryState.DELIVERED_AT_WAREHOUSE,
    ]
  ],
  [
    DeliveryPhase.CANCELLED, [
      DeliveryState.CANCELLED,
    ]
  ]
  ]
)

export enum PaymentState {
  UNPAID = 'UNPAID',
  PENDING_PAYMENT_BY_DRIVER = 'PENDING_PAYMENT_BY_DRIVER',
  PAID_BY_DRIVER = 'PAID_BY_DRIVER',
  PENDING_PAYMENT_TO_MERCHANT = 'PENDING_PAYMENT_TO_MERCHANT',
  PAID_TO_MERCHANT = 'PAID_TO_MERCHANT'
}

export enum Workflow {
  STANDARD = 'STANDARD',
  RETURN = 'RETURN',
}
